import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcpFormFieldComponent } from './fcp-form-field.component';
import { FcpErrorModule } from '../fcp-error/fcp-error.module';

@NgModule({
    declarations: [FcpFormFieldComponent],
    imports: [CommonModule, FcpErrorModule],
    exports: [FcpFormFieldComponent]
})
export class FcpFormFieldModule {}
